import Vue from 'vue'
import Router from 'vue-router'
const Connexion = () => import('@/components/auth/SignIn')
const Inscription = () => import('@/components/auth/SignUp')
const Index = () => import('@/components/Congo')
const Apropos = () => import('@/components/About')
const Producteurs = () => import('@/components/producteurs/Index')
const ProducteurProvinces = () => import('@/components/producteurs/producteur/Index')
const Category = () => import('@/components/produits/productCategories/Index')
const Equipe = () => import('@/components/Team')
const Panier = () => import('@/components/utilisateur/shoppingCart/Index')
const Privacy = () => import('@/components/Privacy')
const Terms = () => import('@/components/Terms')
const AdminDashboard = () => import('@/components/adminDashboard/Index')
Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/apropos',
      name: 'Apropos',
      component: Apropos
    },
    {
      path: '/connexion',
      name: 'Connexion',
      component: Connexion
    },
    {
      path: '/inscription',
      name: 'Inscription',
      component: Inscription
    },
    {
      path: '/producteurs',
      name: 'Producteurs',
      component: Producteurs
    },
    {
      path: '/producteurs/:id',
      name: 'ProducteurProvinces',
      component: ProducteurProvinces
    },
    {
      path: '/équipe',
      name: 'Equipe',
      component: Equipe
    },
    {
      path: '/panier',
      name: 'panier',
      component: Panier
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/console/admin/dashboard',
      name: 'AdminDashboard',
      component: AdminDashboard
    },
    {
      path: '/gamme/:id',
      name: 'Category',
      component: Category
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js